// extracted by mini-css-extract-plugin
export var addButton = "_5w-d";
export var bullets = "_5w-e";
export var compact = "_5w-2";
export var container = "_5w-j";
export var extendedWarrantyModal = "_5w-f";
export var learn = "_5w-l";
export var learnMore = "_5w-g";
export var offeringOption = "_5w-3";
export var offeringPrice = "_5w-8";
export var offeringSubtitle = "_5w-7";
export var offeringTitle = "_5w-6";
export var offeringsContainer = "_5w-0";
export var pdpTilesBackground = "_5w-n";
export var plan = "_5w-m";
export var regular = "_5w-1";
export var remove = "_5w-k";
export var seeDetailsIcon = "_5w-i";
export var seeDetailsLink = "_5w-h";
export var selectedOption = "_5w-4";
export var shieldIcon = "_5w-b";
export var shieldIconCompact = "_5w-c";
export var subtitle = "_5w-a";
export var title = "_5w-9";
export var unselectedOption = "_5w-5";